const uk = {
  questionPaperLibrary: "Biblioteka testovykh materialiv",
  questionPaperLibraryDescription:
    "Vash dynamichnyy robochyy prostir dlya stvorennya okremykh zapytan i rozrobky kompleksnykh testovykh arkhiviv.",
  assessmentLibrary: "Biblioteka otsinyuvannya",
  assessmentLibraryDescription:
    "Keruyte rozkladamy, zaproshuyte uchasnykiv ta vidstezhuyte zvity pro produktyvnist v odnomu tsentralizovanomu habi.",
  myAssessmentWidgetTitle: "Moye otsinyuvannya",
  myPreferences: "Мої налаштування",
  assessmentsForYou: "Otsinyuvannya dlya vas",
  exploreAssessmentsAssignedToYou: "Perehlyante otsinyuvannya, pryznacheni vam",
  hitachiAcademy: "Akademiya Hitachi",
  essentialBusinessKnowledgeTestForYou: "Klyuchovyy test biznes-znan dlya vas",
  continuousLearningJourneyDescription:
    "Stvoreno, shchob dopomohty vam zrozumity ta posylyty svoi biznes-navychky protyahom bezperervnogo navchannya",
  noActiveAssessmentsScheduledForYou:
    "Dlya vas nemae zaplanovanykh aktyvnykh otsinyuvan",
  upcoming: "Maybutnye",
  notAttempted: "Ne sprobuvano",
  myAssessmentCardDescription:
    "Tse otsinyuvannya otsinyuye vashi tekhnichni, analitychni ta navychky rozvyazannya problem yak chastynu kampusnogo procesu naymu v GlobalLogic.",
  totalDuration: "Zahalna tryvalist",
  startTime: "Chas pochatku",
  questionAuthoring: "Stvorennya pytan",
  reviewQuestions: "Perehlyad zapytan",
  bulkUploadHistory: "Istoriya masovogo zavantazhennya",
  bulkActionHistory: "Istoriya masovykh diy",
  editQuestion: "Redaguvaty pytannya",
  inviteParticipants: "Zaprosyty uchasnykiv",
  externalUserBulkUploadHistory:
    "Istoriya masovogo zavantazhennya zovnishnikh korystuvachiv",
  assessmentSchedule: "Hrafik otsinyuvannya",
  assessmentReport: "Zvit otsinyuvannya",
  bulkHistory: "Masova istoriya",
  myUpload: "Moye zavantazhennya",
  bulkUpload: "Masove zavantazhennya",
  createQuestion: "Stvoryty pytannya",
  bulkUploadQuestions: "Masove zavantazhennya zapytan",
  filters: "Filtry",
  clear: "Ochystyty",
  searchByTitle: "Poshuk za nazvoyu",
  refresh: "Onovyty",
  refreshing: "Onovlennya",
  reviewQuestionPapers: "Perehlyad testovykh arkhiviv",
  myQuestionPapers: "Moyi testovi arkhivy",
  viewQuestionBank: "Perehlyanuty bank zapytan",
  createNew: "Stvoryty nove",
  sortBy: "Sortuvaty za",
  state: "Stan",
  reviewed: "Perevireno",
  reviewedTooltip:
    "Pokazaty testovi arkhivy, yaki buly perevireni ta potim opublikovani.",
  all: "Usi",
  draft: "Chornovyk",
  published: "Opublikovano",
  inReview: "Na perevirtsi",
  sentBack: "Povernuto",
  readyToPublish: "Hotovo do publikatsiyi",
  draftDescription:
    "Stvorennya testovoho arkhivu vse shche tryvaye i poky nedostupne dlya uchasnykiv",
  publishedDescription: "Testovyy arkhiv aktyvnyy i dostupnyy dlya uchasnykiv",
  inReviewDescription: "Testovyy arkhiv na perevirtsi i shche ne zatverdzhenyy",
  sentBackDescription: "Testovyy arkhiv bulo poverneno na doopratsyuvannya",
  readyToPublishDescription: "Testovyy arkhiv hotovyy do publikatsiyi",
  createdAt: "Stvoreno",
  updatedAt: "Onovleno",
  publishedAt: "Opublikovano",
  descending: "Za spadannyam",
  ascending: "Za zrostannyam",
  success: "Uspikh",
  error: "Pomylka",
  warning: "Poperedzhennya",
  info: "Informatsiya",
  yes: "Tak",
  no: "Ni",
  noMatchingContentFound: "Vidpovidnyy vmist ne znaydeno",
  noQuestionPapersAvailableForReview:
    "Nemae dostupnykh testovykh arkhiviv dlya perevirky",
  questionPaperNotYetCreated: "Testovyy arkhiv shche ne stvoreno",
  createQuestionPaperDescription:
    "Stvorit testovyy arkhiv dlya otsinky navychok i znan uchasnykiv",
  createYourFirstQuestionPaper: "Stvorit sviy pershyy testovyy arkhiv",
  createQuestionPaperModalTitle: "Stvoryty testovyy arkhiv",
  questionsTab: "Питання",
  questionPaperSettingsTab: "Налаштування паперу із запитаннями",
  editQuestionPaper: "Редагувати анкету",
  save: "зберегти",
  publish: "Опублікувати",
  sendForReview: "Надіслати на перевірку",
  sendingForReview: "Відправка на перевірку",
  publishing: "Видавництво",
  clone: "Клон",
  delete: "Видалити",
  view: "Переглянути",
  edit: "Редагувати",
  close: "Закрити",
  create: "Створити",
  creating: "Створення",
  confirm: "Підтвердити",
  cancel: "Скасувати",
  version: "Версія",
  untitled: "Без назви",
  noVersion: "Без версії",
  title: "Назва",
  status: "Статус",
  action: "Дія",
  createdBy: "Створено",
  createNewVersion: "+ Нова версія",
  createNewVersionTitle: "Створити нову версію",
  deleteQuestionPaperPrompt: "Ви впевнені, що хочете видалити цю анкету?",
  deleteQuestionPaperWithTitlePrompt:
    'Ви бажаєте видалити цю анкету під назвою "{{title}}"?',
  cloneQuestionPaperPrompt: "Ви хочете клонувати цю анкету?",
  publishQuestionPaperPrompt: "Ви впевнені, що бажаєте опублікувати цю анкету?",
  sendForReviewQuestionPaperPrompt:
    "Ви впевнені, що бажаєте надіслати цю анкету для перевірки?",
  successfullyDeletedQuestionPaper: "Лист із запитаннями успішно видалено",
  successfullyMovedQuestionPaperToDraft:
    "Папір із запитаннями успішно переміщено на чернетку",
  successfullySavedQuestionPaperData: "Дані анкети успішно збережено",
  successfullyClonedQuestionPaper: "Папір із запитаннями успішно клоновано",
  successfullyCreatedQuestionPaper: "Питання успішно створено",
  validationFailedWithFollowingErrors: "Помилка перевірки з такими помилками:",
  failedStatusUpdateOf: "Помилка оновлення статусу для:",
  savedWithFollowingWarnings: "Збережено з такими попередженнями:",
  reviewedAndPublished: "Переглянуто та опубліковано",
  deleting: "Видалення...",
  cloning: "Клонування...",
  assessment: "Оцінка",
  public: "Громадський",
  private: "Приватний",
  visibility: "Видимість",
  questionType: "Тип питання",
  selectQuestionTypeAndVisibility: "Виберіть тип запитання та видимість",
  singleChoice: "Єдиний вибір",
  multipleChoice: "Множинний вибір",
  trueOrFalse: "Правда чи хибність",
  fillInTheBlanks: "Заповніть пропуски",
  codingQuestion: "Питання кодування",
  subjectiveQuestion: "Суб'єктивне питання",
  speakingQuestion: "Говорячи питання",
  downloadTemplateEditAndReuploadQuestions:
    "Завантажте шаблон, відредагуйте та повторно завантажте список питань",
  downloadExcelTemplateInstruction:
    "Завантажте шаблон Excel за допомогою кнопки нижче.",
  addQuestionsToSheetInstruction:
    "Додайте свої запитання до аркуша (інструкції включені всередину).",
  uploadCompletedExcelInstruction:
    "Завантажте заповнений файл Excel для масового імпорту запитань.",
  uploading: "Завантаження...",
  uploadQuestions: "Завантажити запитання",
  completed: "Виконано",
  invalid: "Недійсний",
  initiated: "Започатковано",
  failed: "Не вдалося",
  fileName: "Ім'я файлу",
  templateType: "Тип шаблону",
  uploadedAt: "Завантажено на",
  actions: "Дії",
  mcqTemplate: "Шаблон MCQ",
  fibTemplate: "Шаблон FIB",
  monitorUploadExcelDescription:
    "Слідкуйте за кожним завантаженим файлом Excel, перевіряйте, скільки запитань було додано чи не вдалося, і за потреби переглядайте деталі помилки.",
  reset: "Скинути",
  showing: "Показ",
  to: "до",
  of: "з",
  results: "результати",
  noExcelFound: "Excel не знайдено",
  cloneAssessmentConfirmation: "Підтвердження оцінки клону",
  cloneAssessmentWithTitlePrompt:
    'Ви впевнені, що хочете скопіювати це оцінювання під назвою "{{title}}"?',
  successfullyClonedAssessment: "Оцінювання успішно скопійовано",
  newVersionContentPrompt:
    "Ви збираєтеся створити нову версію цього вмісту. Будь-які подальші зміни буде збережено в цій версії. Бажаєте продовжити?",
  createVersionWithNumber: "Створити (V{{version}})",
  addYourComment: "Додайте свій коментар",
  maxLimitReached: "максимальний ліміт досягнуто",
  deleteContentPrompt: "Ви впевнені, що хочете видалити цей {{contentType}}?",
  deleteContentWithTitlePrompt:
    'Ви впевнені, що хочете видалити цей {{contentType}} під назвою "{{title}}"?',
  schedulePreview: "Попередній перегляд розкладу",
  reschedule: "Перепланувати",
  cancelled: "Скасовано",
  copyLink: "Копіювати посилання",
  assessmentIsCancelled: "Оцінка скасовується",
  deleteConfirmation: "Підтвердження видалення",
  cancelConfirmation: "Скасувати підтвердження",
  deleteAssessmentPrompt: "Ви впевнені, що хочете видалити це оцінювання?",
  cancelAssessmentPrompt: "Ви впевнені, що хочете скасувати це оцінювання?",
  rescheduleAssessment: "Перепланувати оцінку",
  customTermsAndConditions: "Спеціальні положення та умови",
  viewTermsAndConditions: "Переглянути T&C",
  scheduleNewAssessment: "Заплануйте нове оцінювання",
  selectQuestionPaper: "Виберіть Питання",
  createAssessment: "Створити оцінювання",
  failedToLoadData: "Не вдалося завантажити дані!",
  assessmentNotYetCreated: "Оцінка ще не створена",
  createAssessmentDescription:
    "Створіть оцінювання, щоб оцінити навички та знання учнів",
  createYourFirstAssessment: "Створіть свою першу оцінку",
  failedToLoadSchedules: "Не вдалося завантажити розклади",
  errors: "Помилки:",
  basicInformation: "Основна інформація",
  assessmentName: "Назва оцінки",
  na: "NA",
  scheduleInstructions: "Розклад інструкцій",
  noInstructionsProvided: "Інструкції не надано",
  accessCriteria: "Критерії доступу",
  searchTags: "Теги пошуку",
  viewAttributes: "Перегляд атрибутів",
  termsAndConditions: "Правила та умови",
  enabled: "Увімкнено",
  disabled: "Вимкнено",
  requireCandidatesToAcceptTerms:
    "Вимагайте від кандидатів прийняти T&C перед початком оцінювання",
  proctoringSettings: "Параметри захисту",
  enableVideoProctoring: "Увімкнути захист відео",
  maximumVideoViolationsAllowed: "Максимально допустимі порушення відео",
  enableBrowserProctoring: "Увімкнути захист браузера",
  maximumBrowserViolationsAllowed:
    "Максимальна допустима кількість порушень браузера",
  displayViolationsToCandidates: "Покажіть порушення кандидатам",
  actionWhenViolationLimitReached: "Дія, коли досягнуто межі порушення",
  flagged: "Позначено",
  terminate: "Отримати",
  stakeholdersAndFeedback: "Зацікавлені сторони та відгуки",
  owner: "Власник",
  recruiter: "Вербувальник",
  allowCandidateFeedback: "Дозволити відгуки кандидатів",
  enableCandidateFeedbackDescription:
    "Дозволити кандидатам надсилати відгуки після завершення оцінювання",
  schedulingAndTimerSettings: "Планування та налаштування таймера",
  scheduleType: "Тип розкладу",
  loginWindow: "Вікно входу",
  durationBased: "На основі тривалості",
  deadline: "Дедлайн",
  autoCompleteMode: "Режим автозаповнення",
  startDateAndTime: "Дата й час початку",
  loginWindowInMinutes: "Вікно входу (у хвилинах)",
  endDateAndTime: "Дата й час завершення",
  timerEnabled: "Таймер увімкнено",
  assessmentRules: "Правила оцінювання",
  assessmentPattern: "Шаблон оцінювання",
  resultVisibility: "Видимість результату",
  passPercentage: "Прохідний відсоток",
  maximumAttemptsAllowed: "Максимально допустима кількість спроб",
  unlimitedAttempts: "Необмежена кількість спроб",
  attempt: "спроба",
  attempts: "спроби",
  coolOffPeriodBetweenAttempts: "Період охолодження між спробами",
  questionDisplaySettings: "Налаштування відображення запитань",
  showQuestionTitle: "Показати назву запитання",
  showQuestionTitleDescription:
    "Відображайте назву запитання над кожним запитанням",
  showHint: "Показати підказку",
  hintLoading: "Вам потрібно почекати, перш ніж побачити іншу підказку",
  allHintsShown: "Немає очікуваних підказок",
  showHintDescription:
    "Увімкніть підказки, щоб допомогти кандидату під час оцінювання",
  showExplanation: "Показати пояснення",
  hideExplanation: "Сховати пояснення",
  showExplanationDescription: "Показувати пояснення після кожного запитання",
  showQuestionMarks: "Показати знаки питання",
  showQuestionMarksDescription: "Відобразіть оцінку/бал для кожного запитання",
  showWatermark: "Показати водяний знак",
  showWatermarkDescription:
    "Відображати електронну адресу кандидата для кожного запитання як водяний знак",
  questionPaperPreview: "Попередній перегляд паперу із запитаннями",
  questionPaperReview: "Рецензія на запитання",
  createSchedule: "Створити розклад",
  reviewerComments: "Коментарі рецензента",
  reviewComments: "Огляд коментарів",
  sendBackQuestionPaperPrompt:
    "Ви впевнені, що бажаєте надіслати цей лист із запитаннями?",
  moveQuestionPaperToDraftPrompt:
    "Ви впевнені, що бажаєте перемістити цю анкету до чернетки?",
  markQuestionPaperReadyToPublishPrompt:
    "Ви впевнені, що бажаєте позначити цей документ готовим до публікації?",
  questionPaperStatusUpdatedSuccessfully: "Статус анкети успішно оновлено!",
  newVersionQuestionPaperCreatedSuccessfully:
    "Успішно створено нову версію анкети!",
  questionPaperClonedSuccessfully: "Питання успішно клоновано!",
  startAddingQuestionsPreview:
    "Почніть додавати запитання, щоб переглянути їх тут",
  bulkInviteParticipants: "Масове запрошення учасників",
  bulkInviteParticipantsDescription:
    "Запросіть кількох учасників одночасно, завантаживши попередньо заповнений файл Excel. Щоб забезпечити правильний формат, використовуйте наданий шаблон.",
  maxParticipantsPerFileNote:
    "Макс. 200 учасників на файл. Дублікати або недійсні записи будуть пропущені з помилкою.",
  downloadTemplate: "Завантажити шаблон",
  creatingUser: "Створення користувача...",
  bulkInviteLabel: "Масове запрошення",
  createAndInvite: "Створити та запросити",
  myUploads: "Мої завантаження",
  enterIndividualsForInvite:
    "Введіть імена однієї або кількох осіб, яких ви хочете запросити для оцінювання",
  searchPeopleByEmailOrName: "Пошук людей за електронною поштою або іменем",
  noResultsFound: "Результатів не знайдено",
  loading: "Завантаження..",
  or: "Або",
  multipleEmailsInviteDescription:
    "Додайте кілька електронних адрес користувачів, розділених комами, щоб запросити кількох користувачів до оцінювання",
  addCandidates: "Додати кандидатів",
  pleaseEnterValidNameOrEmail: "Введіть дійсне ім'я або електронну адресу",
  pleaseEnterValidEmailAddress: "Введіть дійсну електронну адресу",
  someEmailsCouldNotBeAdded: "Не вдалося додати деякі адреси електронної пошти",
  checkInvalidEmailIds:
    "Будь ласка, перевірте наступні ідентифікатори електронної пошти - здається, вони недійсні:",
  failedToSendInvitesFollowingEmails:
    "Не вдалося надіслати запрошення на такі електронні адреси:",
  successfullyInvitedMembers: "{{count}} учасника успішно запрошено",
  validationFailed: "Помилка перевірки",
  excelUploadedSuccessfully: "Excel успішно завантажено",
  invalidBulkNominationTemplate: "Недійсний шаблон масової номінації",
  actionCompletedWithWarnings: "Дія завершена з такими попередженнями:",
  actionFailedWithErrors: "Не вдалося завершити дію та вийти з таких помилок:",
  trackBulkOperationsAndResults:
    "Відстежуйте всі свої масові операції та їх результати",
  partiallySaved: "Частково збережено",
  statusInitiatedDescription:
    "Запит на оновлення питання подано та обробляється.",
  statusCompletedDescription: "Усі вибрані запитання успішно оновлено.",
  statusFailedDescription:
    "Жодне з вибраних питань не вдалося успішно обробити.",
  statusPartiallySavedDescription:
    "Деякі запитання успішно збережено, а в інших виникли проблеми.",
  draftReadyToPublishToPublish: "Чернетка/готова до публікації -> Опублікувати",
  actionType: "Тип дії",
  uploadedOn: "Завантажено",
  viewDetails: "Переглянути деталі",
  loadingRecords: "Завантаження записів...",
  noRecordsFound: "Записів не знайдено",
  recordsPerPage: "Записів на сторінці:",
  page: "Сторінка",
  untitledQuestion: "Питання без назви",
  globalLogic: "GlobalLogic",
  aiGenerated: "AI Genered",
  fullScreen: "Повний екран",
  exitFullScreen: "Вийти з повного екрана",
  skills: "Навички",
  tags: "Теги",
  allowedCodingLanguages: "Дозволені мови кодування",
  marks: "Відмітки",
  lastUpdatedAt: "Останнє оновлення о",
  solutionCode: "Код рішення",
  solution: "Рішення",
  starterCode: "Початковий код",
  options: "Опції",
  explanation: "Пояснення",
  hint: "Підказка",
  deleteQuestion: "Видалити питання",
  noSections: "Не додано розділів",
  editAndPublish: "Редагувати та опублікувати",
  sendBackToDraftInstruction:
    'Натисніть кнопку "Надіслати", щоб повернути запитання до чернетки.',
  updateStatusReadyToPublishInstruction:
    "Щоб оновити статус, натисніть кнопку Готово до публікації.",
  successfullyUpdatedStatus: "Успішно оновлено статус",
  dismiss: "Відхилити",
  ongoing: "Триває",
  toBeLaunched: "Буде запущено",
  contentExpired: "Термін дії контенту минув",
  notApplicable: "Не застосовується",
  expiresSoon: "Скоро закінчується",
  contentCreationInProgressTooltip:
    "Створення контенту ще триває і поки недоступне для учнів",
  contentLiveAccessibleTooltip:
    "Контент опубліковано і він доступний для учнів",
  contentAvailableWithinDatesTooltip:
    "Контент наразі доступний, оскільки знаходиться в межах дат запуску та завершення",
  contentNotLaunchedAvailableOnTooltip:
    "Контент ще не запущено і він буде доступний",
  contentExpiredOnTooltip: "Термін дії цього контенту завершився",
  statusAvailableAfterPublishTooltip:
    "Статус буде доступний після публікації контенту",
  contentExpiresWithin48HoursTooltip:
    "Термін дії контенту завершиться протягом 48 годин.",
  moveToDraftOrCloneToEdit:
    "Перемістіть у чернетку або клонувати, щоб внести зміни",
  webContent: "Вебконтент",
  eLearning: "Е-навчання",
  untitledContent: "Контент без назви",
  sendToDraft: "Надіслати в чернетку",
  sendToDraftPublishedInstruction:
    "Цей контент уже опубліковано. Щоб внести зміни, натисніть кнопку Надіслати в чернетку.",
  copyLinkForLearner: "Скопіювати посилання для учня",
  questionPaperName: "Назва набору запитань",
  type: "Тип",
  duration: "Тривалість",
  minutes: "Хвилини",
  difficultyLevel: "Рівень складності",
  language: "Мова",
  timezone: "Часовий пояс",
  preferredLocation: "Бажане місце",
  notSelected: "Не вибрано",
  selectedPreferencesHeading: "Вибрані налаштування",
  selectedPreferencesInfo: "Вибрані налаштування для комфортної роботи",
  shortDescription: "Короткий опис",
  totalMarks: "Загальна кількість балів",
  questionPaperInstructions: "Інструкції до набору запитань",
  expiryDate: "Дата завершення",
  knowledgeCategory: "Категорія знань",
  category: "Категорія",
  subCategory: "Підкатегорія",
  region: "Регіон",
  usage: "Використання",
  internalUseOnly: "Лише для внутрішнього використання",
  externalUseOnly: "Лише для зовнішнього використання",
  availableForAll: "Доступно для всіх",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Латинська Америка",
  northAmerica: "Північна Америка",
  globalRegion: "Глобальний",
  automotive: "Автомобільна",
  bankingFinancialServicesInsurance:
    "Банківська, фінансові послуги та страхування",
  connectivitySolutionsCommunication: "Рішення для підключення/зв'язку",
  consumerRetail: "Споживчі товари та роздрібна торгівля",
  healthcareLifeSciences: "Охорона здоров'я та науки про життя",
  manufacturingAndIndustrial: "Виробництво та промисловість",
  mediaEntertainment: "Медіа та розваги",
  technology: "Технологія",
  other: "Інше",
  behavioralInterpersonal: "Поведінкове/міжособистісне",
  technical: "Технічне",
  processAndTools: "Процеси та інструменти",
  polishLanguage: "Польська",
  spanishLanguage: "Іспанська",
  japaneseLanguage: "Японська",
  germanLanguage: "Німецька",
  ukrainianLanguage: "Українська",
  swedishLanguage: "Шведська",
  romanianLanguage: "Румунська",
  slovakLanguage: "Словацька",
  croatianLanguage: "Хорватська",
  englishUsLanguage: "Англійська (US)",
  englishUkLanguage: "Англійська (UK)",
  englishInLanguage: "Англійська (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Автомобільні стандарти та протоколи",
  businessAnalysis: "Бізнес-аналіз",
  cCpp: "C/C++",
  cloudDataScience: "Хмарна наука про дані",
  bigData: "Big Data",
  dataAnalytics: "Аналітика даних",
  databaseTech: "База даних",
  developmentTools: "Інструменти розробки",
  devops: "DevOps",
  embedded: "Вбудовані системи",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linux kernel",
  mobileDev: "Мобільна розробка",
  networking: "Мережі",
  operatingSystemsServers: "Операційні системи та сервери",
  otherTech: "Інше - Tech",
  productivityTools: "Інструменти продуктивності",
  programmingLangOther: "Мова програмування - Інше",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Програмна інженерія",
  uxUi: "UX/UI",
  architectureTech: "Архітектура",
  golang: "Golang",
  requirementEngineeringTechnicalWriting: "Інженерія вимог/Технічне письмо",
  onboarding: "Онбординг",
  glTools: "GL інструменти",
  processAndPolicies: "Процеси та політики",
  communicationSubCategory: "Комунікація",
  personalEffectiveness: "Особиста ефективність",
  methodologies: "Методології",
  projectManagement: "Управління проєктами",
  peopleManagement: "Управління людьми",
  leadershipPrograms: "Лідерські програми",
  domain: "Домен",
  reviewer: "Рецензент",
  none: "Немає",
  questionPaperPreviewBreadcrumb:
    "Попередній перегляд набору питань: {{title}}",
  questionPaperInReviewContactReviewer:
    "Цей набір питань наразі на рецензуванні. Будь ласка, зв’яжіться з рецензентом.",
  randomization: "Рандомізація",
  randomizationInSectionDescription:
    "Питання в цьому розділі будуть показані кандидатам у випадковому порядку",
  questionPreviewPlaceholderImage:
    "Заповнювач попереднього перегляду запитання",
  createNewVersionPromptWithNumber: "Створити нову версію (V{{version}})?",
  questionPreviewBreadcrumb: "Попередній перегляд питання: {{title}}",
  questionPreviewTitle: "Попередній перегляд питання",
  adminView: "Режим адміністратора",
  candidateView: "Режим кандидата",
  viewAsCandidate: "Переглянути як кандидат",
  closePanel: "Закрити панель",
  internalQuestion: "Внутрішнє питання",
  expiresOn: "Дійсне до",
  expiredLabel: "Термін дії минув",
  solutionNotAdded: "Рішення не додано",
  testCases: "Тестові випадки",
  testCasesNotAdded: "Тестові випадки не додано",
  starterCodeNotAdded: "Початковий код не додано",
  groupTitleLengthValidation:
    "Назва групи має містити більше 5 і менше 120 символів",
  addTitleHere: "Додайте назву тут...",
  groupUpdatedSuccessfully: "Групу успішно оновлено",
  groupDeletedSuccessfully: "Групу успішно видалено",
  group: "Група",
  numberOfQuestionsToBeShown: "Кількість питань для показу",
  questionLimitPerSectionDescription:
    "Показуйте кандидатам у розділах лише певну кількість питань",
  numberOfQuestionsToShow: "Кількість питань для показу {{picked}}/{{total}}",
  collapseGroup: "Згорнути групу",
  expandGroup: "Розгорнути групу",
  groupSetupStartAddingQuestions:
    "Для цього розділу налаштовано групу. Почніть додавати до неї питання.",
  addMoreQuestions: "Додати більше питань",
  addQuestionFromLibrary: "Додати питання з бібліотеки",
  questionDeletedSuccessfully: "Питання успішно видалено",
  questionsShownCountUpdated: "Кількість показаних питань оновлено",
  failedToDeleteQuestion: "Не вдалося видалити питання",
  caseSensitive: "Чутливість до регістру",
  caseSensitiveDescription:
    "Якщо ввімкнено, учні мають ввести відповідь з точно таким самим регістром літер.",
  enterYourAnswerBelow: "Введіть свою відповідь нижче",
  caseSensitiveAnswerInfo:
    "Це питання чутливе до регістру, тому введіть відповіді з точним регістром великих і малих літер.",
  answerWithNumber: "Відповідь {{number}}",
  inviteEmailsPlaceholder: "user1@globallogic.com, user2@globallogic.com",
  visibleTestCases: "Видимі тест-кейси",
  hiddenTestCases: "Приховані тест-кейси",
  visibleLabel: "Видимий",
  hiddenLabel: "Прихований",
  responseSetting: "Налаштування відповіді",
  recordingLimit: "Ліміт запису",
  minimumResponseDuration: "Мінімальна тривалість відповіді",
  uploadLimit: "Ліміт завантаження",
  practiceAllowed: "Практику дозволено",
  standardEvaluationRubricInfo:
    "Це стандартна оціночна рубрика, яка буде використовуватися для оцінювання відповіді кандидата на це запитання.",
  criteria: "Критерії",
  weightPercentage: "Вага(%)",
  viewRemarks: "Переглянути примітки",
  input: "Введення",
  expectedOutput: "Очікуваний результат",
  actualOutput: "Фактичний результат",
  untitledSection: "Розділ без назви",
  testSectionDescription: "Опис тестового розділу",
  groupAddedSuccessfully: "Групу успішно додано",
  addGroupToSection: "Додати групу до розділу",
  deleteSection: "Видалити розділ",
  questionPaperDetails: "Деталі документа з питань",
  skillsInfoMessage:
    "Перелічіть ключові навички, які має оцінювати цей документ з питань.",
  contentSettings: "Налаштування вмісту",
  stakeholderAndReview: "Зацікавлені сторони та перегляд",
  statusType: "Тип статусу",
  notReviewed: "Не перевірено",
  sourceType: "Тип джерела",
  proficiency: "майстерність",
  beginner: "Початківець",
  intermediate: "Проміжний",
  advanced: "Просунутий",
  wecp: "WECP",
  enterMarks: "Введіть позначки",
  removeSkill: "Видалити навик",
  searchSkills: "Навички пошуку",
  noSkillsFound: "Навички не знайдено.",
  enterTag: "Введіть тег",
  enterOwner: "Введіть власника",
  enterReviewer: "Введіть рецензента",
  noUserWithRole: "Користувача з цією роллю не знайдено",
  createSection: "Створити розділ",
  untitledGroup: "Група без назви",
  createGroup: "Створити групу",
  collapseSections: "Згорнути розділи",
  expandSections: "Розгорнути розділи",
  assessmentNamePlaceholder: "Будь ласка, введіть назву оцінювання",
  questionPaperTitleInfo:
    "Введіть чітку, описову назву для листа із запитаннями.",
  shortDescriptionPlaceholder: "Надайте короткий опис",
  shortDescriptionInfo:
    "Коротке резюме, що пояснює, що охоплює тестова робота.",
  questionPaperInstructionsInfo:
    "Напишіть інструкції, які кандидати побачать перед тим, як почати роботу з запитаннями. Додайте такі важливі деталі, як правила розділу, формати запитань, підказки щодо навігації та вказівки щодо подання.",
  questionPaperInstructionsPlaceholder:
    "Додайте будь-які важливі інструкції для учнів перед початком оцінювання – тривалість, критерії проходження, дозволені інструменти чи вказівки.",
  totalMarksAutoCalculatedInfo:
    "Загальна кількість балів буде автоматично підрахована на основі кількості питань, вибраних для кожної групи. Якщо кількість запитань для показу встановлена ​​на 0, ця група буде виключена із загальної кількості балів.",
  questionPaperType: "Тип паперу для запитань",
  questionPaperTypeInfo: "Виберіть формат анкети.",
  durationInfo:
    "Встановіть загальний ліміт часу для заповнення анкети (у хвилинах).",
  difficultyLevelInfo:
    "Виберіть очікуваний рівень складності на основі досвіду кандидата.",
  languageInfo: "Виберіть мову, якою буде подано запитання.",
  tagsInfo:
    "Додайте ключові слова, щоб допомогти іншим знайти цю анкету за допомогою пошуку.",
  selectCategory: "Виберіть категорію",
  createLevel: "Створити",
  evaluate: "Оцініть",
  analyze: "Аналізуйте",
  apply: "Застосувати",
  understand: "Зрозумійте",
  remember: "Пам'ятайте",
  allowedCodingLanguagesRequiredInfo:
    "Поле є обов’язковим лише тоді, коли ви додаєте запитання щодо кодування до анкети.",
  knowledgeCategoryInfo:
    "Виберіть рівень когнітивних навичок, на який спрямований цей лист із запитаннями, наприклад «Запам’ятати», «Зрозуміти», «Застосувати».",
  allowedCodingLanguagesInfo:
    "Виберіть мови програмування, дозволені для кодування запитань у цій анкеті.",
  expiryDateInfo:
    "Встановіть необов’язкову дату, після якої цей аркуш із запитаннями більше не використовуватиметься.",
  visibilityInfo: "Виберіть видимість листа із запитаннями",
  visibilityLockedInfo:
    "Після того, як документ із запитанням буде опубліковано з загальнодоступним доступом, усі інші його версії також матимуть публічний доступ. Так само, якщо він опублікований як приватний, усі версії залишаться приватними.",
  reviewRequired: "Рецензія обов'язкова",
  reviewRequiredLockedInfo:
    "Параметр «Потрібна рецензія» синхронізується з усіма версіями запитання. Якщо будь-яка версія опублікована з увімкненим або вимкненим переглядом, той самий параметр застосовуватиметься до всіх версій, і його неможливо редагувати окремо.",
  reviewRequiredInfo:
    "Увімкніть, якщо цей документ із запитаннями має пройти офіційний процес перевірки перед публікацією.",
  savingData: "Збереження даних...",
  questionDataSavedSuccessfully: "Дані питання успішно збережено",
  sendQuestionForReviewInstruction:
    "Натисніть кнопку «Надіслати на перевірку», щоб надіслати його рецензенту для перевірки!",
  publishQuestionInstruction:
    "Натисніть кнопку опублікувати, щоб опублікувати запитання.",
  noLearningContentAddedAfterSelectingYes:
    "Після вибору «Так» не додано навчальний вміст",
  expectedTimeInMinutes: "Очікуваний час (у хв.)",
  codingMarksAutoCalculatedInfo:
    "Ці оцінки обчислюються автоматично на основі прихованих тестів, доданих до цього запитання",
  skillsInfoMessageQuestion:
    "Надайте конкретні навички, які учасники набудуть із запитання",
  skillsSubtitleQuestion: "Встановіть навички, пов’язані з цим питанням",
  allowedCodingLanguagesInfoQuestion:
    "Виберіть доступні мови для вирішення цього питання",
  selectCodingLanguages: "Виберіть мови кодування",
  allLanguages: "Усі мови",
  tagsInfoQuestion:
    "Надайте ключові слова для класифікації, опису та визначення події",
  tagsSubtitleQuestion: "Встановіть теги для швидкого пошуку",
  knowledgeCategorySubtitleQuestion:
    "Допомагає класифікувати питання за рівнем когнітивних навичок.",
  explanationNotAvailableForSpeakingQuestion:
    "Пояснення недоступне для розмовного запитання",
  ownerVersionSyncInfo:
    "Якщо ми змінимо власника цієї версії, вона також оновиться в усіх створених версіях.",
  ownerInfoMessage: "Виберіть основного власника(ів) запитання",
  ownerReviewerCannotBeSame:
    "власник і рецензент не можуть бути одним і тим же",
  reviewerInfoMessage: "Виберіть особу або групу осіб як рецензентів",
  stakeholdersUpdatedSuccessfully: "Зацікавлені сторони успішно оновлено!",
  unexpectedErrorCreatingNewVersion:
    "Під час створення нової версії сталася неочікувана помилка.",
  previewAndPublish: "Попередній перегляд і публікація",
  viewAnalytics: "Перегляд аналітики",
  cloneQuestionPrompt: "Ви хочете клонувати це запитання?",
  evaluationRubric: "Оціночна рубрика",
  problemStatement: "Постановка проблеми",
  problemStatementPlaceholder:
    "Введіть формулювання проблеми або формулювання для тесту",
  addOptionsAndMarkCorrectAnswer:
    "Додайте варіанти та позначте правильну відповідь",
  markCorrectAnswer: "Позначте правильну відповідь",
  addCorrectAnswer: "Додайте правильну відповідь",
  enterCorrectAnswerForBlank:
    "Введіть правильну відповідь для порожнього поля {{number}}",
  blankWithNumber: "Порожнє {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Додайте правильне формулювання проблеми з «&порожнім», щоб увімкнути відповідь.",
  enterSolution: "Введіть рішення",
  enterExplanation: "Введіть Пояснення",
  codingSolutionExplanationPlaceholder:
    "Коротко поясніть логіку, підхід і крайові випадки, які розглядаються в оптимальному рішенні",
  optionWithNumber: "Варіант {{number}}",
  enterExplanationForAnswer: "Введіть пояснення до відповіді {{number}}",
  addOptionToEnableExplanation:
    "Додайте параметр {{number}}, щоб увімкнути пояснення.",
  enterExplanationForBlank: "Введіть пояснення для пустого {{number}}",
  addProblemStatementWithBlankToEnableExplanation:
    "Додайте правильне формулювання проблеми з '&порожнім', щоб увімкнути пояснення.",
  enterHint: "Введіть підказку",
  addUpTo3Hints: "Додайте до 3 підказок",
  addMoreOptions: "Додайте більше опцій",
  answer: "Відповідь",
  exitCodeBlockInfo:
    'Щоб вийти з блоку коду, перейдіть до кінця рядка та тричі натисніть "Enter".',
  fibBlankInsertionInfo:
    'Щоб додати пробіл, виділіть текст і натисніть кнопку "Вставити пробіл" або вручну додайте &blankN, де N може бути будь-яким цілим числом, наприклад: &blank1;',
  htmlEditorAccessInfo:
    "Щоб додати код або керувати форматом, ви можете отримати доступ до редактора HTML, натиснувши значок редагування",
  skillSelectionCannotBeEmpty: "Вибір навичок не може бути порожнім",
  maxDurationInfo:
    "Максимальний час, наданий користувачеві для запису відповіді на це запитання.",
  minDurationInfo:
    "Мінімальний необхідний час запису, який користувач має завершити, перш ніж надіслати свою відповідь.",
  uploadLimitInfo:
    "Скільки разів користувач може перезаписати свою відповідь перед остаточним надсиланням.",
  textQuestionTitle: "Це текстове запитання",
  audioRecordQuestionTitle: "Це запитання щодо аудіозапису",
  audioUploadQuestionTitle: "Це питання щодо завантаження аудіо",
  videoRecordQuestionTitle: "Це питання про відеозапис",
  videoUploadQuestionTitle: "Це питання щодо завантаження відео",
  subjectiveQuestionUploadConfigTitle:
    "Заголовок конфігурації завантаження суб’єктивного запитання",
  recordingLimitInMinutes: "Ліміт запису (хв.)",
  minimumResponseDurationInMinutes: "Мінімальна тривалість відповіді (у хв.)",
  recordingLimitLessThanTwenty: "Ліміт запису має бути менше 20",
  recordingLimitGreaterThanOrEqualOne:
    "Обмеження запису має бути більше або дорівнювати 1",
  minimumDurationLessThanRecordingLimit:
    "Мінімальна тривалість відповіді має бути меншою за ліміт запису",
  durationGreaterThanPointFive: "Тривалість має бути більше 0,5",
  uploadLimitGreaterThanZero: "Обмеження завантаження має бути більше 0",
  addFieldSelectCodingLanguagesInfo:
    "Щоб додати {{fieldLabel}}, спершу виберіть дозволені мови кодування в розділі «{{basicDetails}}».",
  basicDetails: "Основні деталі",
  loadingEditor: "Завантаження редактора...",
  run: "Запустити",
  writingSolutionInLanguage: "Зараз ви пишете рішення",
  changingToLanguageWillClearInput: "Зміна на",
  unsavedChangesWillBeLostInLanguage: "Ваші незбережені зміни в",
  changeLanguage: "Змінити мову",
  testCase: "Тестовий випадок",
  add: "додати",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Нижче додайте щонайменше 2 видимі тести та 3 приховані тести",
  visibleToCandidatesForSelfEvaluation: "Видно кандидатам для самооцінки",
  noVisibleTestCasesAddedYet:
    "Ще не додано видимих ​​тестів. Натисніть кнопку нижче, щоб додати.",
  visibleTestCasesCannotExceedTwenty: "Видимих ​​тестів не може бути більше 20",
  addMoreVisibleTestCases: "Додайте більше видимих ​​тестів",
  maximumTestCasesLimitReached: "Досягнуто максимальної кількості тестів",
  hiddenToCandidatesRunsAfterSubmit:
    "Приховано для кандидатів, запускається після подання кандидата",
  noHiddenTestCasesAddedYet:
    "Прихованих тестів ще не додано. Натисніть кнопку нижче, щоб додати.",
  hiddenTestCasesCannotExceedTen: "Прихованих тестів не може бути більше 10",
  addMoreHiddenTestCases: "Додайте більше прихованих тестів",
  hiddenTestCase: "Прихований тестовий приклад",
  visibleTestCase: "Видимий тестовий приклад",
  someQuestionsCouldNotBeUpdated:
    "Деякі запитання не вдалося оновити. Перегляньте запитання та повторіть спробу.",
  publishSummary: "Опублікувати резюме",
  sendForReviewSummary: "Надіслати на перевірку Резюме",
  moveToDraftSummary: "Перейти до чернетки резюме",
  actionSummary: "Підсумок дії",
  publishSummarySubtitle:
    "Ось підсумок вашої публікації. Перегляньте деталі нижче.",
  sendForReviewSummarySubtitle:
    "Ось короткий виклад вашого запиту на перегляд. Перегляньте деталі нижче.",
  moveToDraftSummarySubtitle:
    "Ось короткий опис вашого переходу до чернетки. Перегляньте деталі нижче.",
  actionSummarySubtitle:
    "Ось короткий зміст ваших дій. Перегляньте деталі нижче.",
  successfully: "Успішно",
  failedTo: "Не вдалося",
  moveToDraft: "Перейти до чернетки",
  details: "Подробиці",
  questionTitle: "Назва питання",
  reason: "Причина",
  showLess: "Показувати менше",
  showMoreCount: "Показати ще {{count}}",
  uploadedAllCountItems: "Завантажено всі {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Частково завантажено {{successCount}}/{{totalCount}} {{item}}",
  users: "користувачів",
  questions: "запитання",
  viewErrors: "Переглянути помилки",
  errorsWithFileName: "Помилки - {{fileName}}",
  inputIsRequired: "Необхідно ввести",
  expectedOutputIsRequired: "Потрібен очікуваний результат",
  expectedOutputCannotBeBlank:
    "Очікуваний вихід не має бути порожнім або лише пробілами",
  marksMustBeNumber: "Позначки мають бути цифрами",
  marksAreRequired: "Відмітки обов'язкові",
  hiddenTestCaseMarksGreaterThanZero:
    "Оцінки для прихованих тестів мають бути більшими за 0, щоб продовжити.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Бали за приховані тести не повинні перевищувати 30 000.",
  explanationMinFiveIfProvided:
    "Пояснення повинно містити щонайменше 5 символів, якщо воно надається",
  explanationIsRequired: "Потрібне пояснення",
  explanationMinFiveNotBlank:
    "Пояснення повинно містити принаймні 5 символів, а не лише пробіли",
  provideInput: "Введіть дані",
  provideExpectedOutput: "Надайте очікуваний результат",
  enterScore: "Введіть оцінку",
  optional: "необов'язковий",
  explainTestCase: "Поясніть тестовий приклад",
  updateTestCase: "Оновити тестовий приклад",
  addTestCase: "Додати тестовий приклад",
  deleteQuestionWithTitlePrompt:
    "Ви впевнені, що хочете видалити це запитання з назвою '{{title}}'?",
  errorFetchingData: "Помилка отримання даних",
  rowNumber: "Номер рядка",
  columnName: "Назва стовпця",
  useCase: "Випадок використання",
  startsAt: "Початок о",
  endsAt: "Закінчується о",
  invite: "Запросити",
  viewReport: "Переглянути звіт",
  successfullyDeletedAssessment: "Оцінку успішно видалено",
  successfullyFreezeActionAssessment: "Успішно {{action}} оцінювання",
  freezeOperationFailed: "Не вдалося заморозити",
  deleteAssessmentWithTitlePrompt:
    'Ви впевнені, що хочете видалити це оцінювання під назвою "{{title}}"?',
  freeze: "Заморозити",
  unfreeze: "Розморозити",
  freezeAssessmentPrompt: "Ви впевнені, що хочете {{action}} це оцінювання?",
  expiresAt: "Термін дії закінчується о",
  seePreview: "Див. Попередній перегляд",
  schedule: "розклад",
  skillBenchmarking: "Порівняльний аналіз навичок",
  skillBenchmarkingOverview:
    "Огляд рівня володіння учасником конкретними навичками.",
  proctoringAnalysis: "Прокторінговий аналіз",
  proctoringAnalysisOverview:
    "Короткий огляд аспектів оцінювання, пов’язаних із наглядом.",
  proctoringStatus: "Прокторський статус",
  noIrregularitiesReported: "Про порушення не повідомляється.",
  monitoringOverview: "Огляд моніторингу",
  complianceNoIncidents:
    "Дотримання правил оцінювання; відсутність інцидентів або позначених дій.",
  viewEvidenceClicked: "Натиснуті докази!",
  marksObtained: "Отримані оцінки",
  correctAnswer: "Правильна відповідь",
  wrongAnswer: "Неправильна відповідь",
  sectionWiseAnalysis: "Розділ мудрий аналіз",
  sectionWiseAnalysisOverview: "Огляд кожного питання та відповідь кандидата.",
  openAllSections: "Відкрити всі розділи",
  closeAllSections: "Закрийте всі розділи",
  sectionWithNumber: "Розділ {{number}}:",
  score: "Оцінка",
  questionAnalysis: "Аналіз питання",
  questionTitleFallback: "Назва питання",
  candidateAnswer: "Відповідь кандидата",
  loadAllQuestions: "Завантажити всі {{count}} {{item}}",
  attemptWithNumber: "Спроба №{{number}}",
  invalidReportUrl: "Недійсна URL-адреса звіту",
  failedToDownloadReportTryAgainLater:
    "Не вдалося завантажити звіт. Спробуйте пізніше!",
  downloadReport: "Завантажити звіт",
  participantName: "Ім'я учасника",
  dateOfAttempt: "Дата спроби",
  fail: "Невдача",
  pass: "Пас",
  userScoredInAssessment: "{{name}} отримав {{percentage}} в оцінюванні.",
  overallSummary: "Загальне резюме",
  sectionAnalytics: "Розділ Аналітика",
  allAttempts: "Всі спроби",
  bestAttempt: "Найкраща спроба",
  latestAttempt: "Остання спроба",
  participantList: "Список учасників",
  totalParticipantsInvited: "Загальна кількість запрошених учасників",
  notStarted: "Не розпочато",
  inProgress: "В роботі",
  resultsInProgress: "Результати в процесі",
  searchByNameOrEmail: "Пошук за іменем або електронною поштою",
  noUsersAvailableReportCannotBeGenerated:
    "Немає доступних користувачів - звіт не може бути створений.",
  userName: "Ім'я користувача",
  totalAttempt: "Тотальна спроба",
  percentage: "Відсоток (%)",
  attemptTimeline: "Часова шкала спроб",
  noDataFound: "Дані не знайдено",
  outOfMarks: "{{obtained}} з {{max}} балів",
  resultInProcess: "Результат у процесі",
  participantNotFound: "Учасника не знайдено!",
  searchedParticipantNotFound: "Пошуковий учасник не знайдено!",
  noParticipantEnrolled: "Немає зареєстрованих учасників!",
  noDataToDisplay: "Немає даних для відображення",
  participantsPerPage: "Учасників на сторінці:",
  actionFailed: "Не вдалося виконати дію",
  failedToRemoveUser: "Не вдалося видалити користувача",
  bestScoreAcrossAttemptsInfo:
    "Вказує на найкращий результат, отриманий за кілька спроб.",
  successfullyRemovedUser: "Користувача успішно видалено",
  successfullyReinvitedUser: "Користувача успішно повторно запросили",
  reinviteTooltip:
    "Повторно запросіть учасників, які ще не розпочали поточне оцінювання",
  reInvite: "Повторно запросити",
  noParticipantsInvitedYet: "Учасників ще не запросили",
  scheduleExpired: "Розклад минув",
  assessmentIsOngoing: "Оцінка триває",
  assessmentCompleted: "Оцінювання завершено",
  resultNotProcessed: "Результат не оброблено",
  assessmentNotStarted: "Оцінювання не розпочато",
  remove: "видалити",
  confirmReInvitation: "Підтвердити повторне запрошення",
  confirmReinviteMessage:
    "Ви впевнені, що хочете повторно запросити учасників, які ще не почали поточне оцінювання?",
  removeUserWithNamePrompt: "Ви впевнені, що хочете видалити '{{name}}'?",
  groupType: "Тип групи",
  objectiveGroupType: "Мета",
  codingGroupType: "Кодування",
  subjectiveTextSpeakingGroupType: "Суб'єктивний (текст / мовлення)",
  groupTypeImmutableInfo:
    "Тип групи не можна змінити пізніше. Можна додавати лише запитання такого типу.",
  sameMarkGroupingTitle:
    "Питання можна групувати, лише якщо вони мають однакову оцінку",
  sameMarkGroupingDescription:
    "Змішування значень балів (наприклад, 2 бали та 5 балів) у групі може призвести до різних балів розділу, коли вибрано лише деякі питання. Групуйте подібні запитання для оцінки, щоб оцінки були узгодженими.",
  searchQuestion: "Пошукове питання",
  addAllSelectedQuestions: "Додати всі {{count}} вибрані запитання",
  singleQuestionSelectedCount: "Вибрано {{count}} запитання",
  allQuestionsSelectedCount: "Усі {{count}} запитань вибрано",
  selectedCountOfTotalQuestions: "Вибрано {{selected}} з {{total}} {{label}}",
  addSelectedQuestion: "Додайте вибране питання",
  validationErrors: "Помилки перевірки",
  failedToAddToGroup: "Не вдалося додати до групи",
  questionsAddedSuccessfullyWithCount: "{{count}} запитань успішно додано",
  successfullyUpdatedAssessment: "Оцінювання успішно оновлено",
  editCustomTnc: "Редагувати власні правила та умови",
  addCustomTnc: "Додати власні правила та умови",
  attributes: "Атрибути",
  added: "Додано",
  addAttributes: "Додати атрибути",
  clickHereToAddEditAttributes:
    "Натисніть тут, щоб додати або редагувати атрибути",
  clickHereToAddAttributes: "Натисніть тут, щоб додати атрибути",
  addTncAndSave: "Додати правила та умови й зберегти",
  savedWithFollowingErrors: "Збережено з наступними помилками",
  selectDomain: "Виберіть домен",
  selectRegion: "Виберіть регіон",
  selectUsage: "Виберіть використання",
  selectCategoryFirst: "Спочатку виберіть категорію",
  selectSubCategory: "Виберіть підкатегорію",
  addAttributesAndSave: "Додати атрибути й зберегти",
  questionPaperTimer: "Таймер для тестових питань",
  sectionLevelTimer: "Таймер на рівні розділу",
  questionLevelTimer: "Таймер на рівні питання",
  loginWindowDescription:
    "Кандидати можуть приєднатися лише протягом обмеженого вікна часу після часу початку.",
  durationBasedDescription:
    "Час завершення автоматично обчислюється як: час початку + тривалість тесту.",
  deadlineDescription:
    "Фіксований час початку та завершення; кандидати повинні закінчити роботу до дедлайну.",
  loginWindowInfo:
    "Вікно входу — це час (у хвилинах), протягом якого кандидати можуть розпочати тестування після запланованого часу початку. Після закриття вікна входу жоден новий кандидат не зможе увійти. Вікно входу має бути меншим або дорівнювати тривалості тесту.",
  assessmentDurationInfo:
    "Встановіть лише час початку. Система автоматично розрахує час завершення, додавши тривалість тесту.",
  startTimeMinAheadInfo:
    "Час початку має бути щонайменше на 15 хвилин більше поточного часу.",
  loginWindowExample:
    "Приклад: Якщо час початку о 9:00, а вікно входу становить 30 хвилин, кандидати можуть розпочати тестування з 9:00 до 9:30 з додатковим 5-хвилинним буфером.",
  assessmentDurationExample:
    "Приклад: Якщо час початку о 9:00, а тривалість тесту становить 60 хвилин, оцінювання завершиться о 10:00 з додатковим 5-хвилинним буфером.",
  freeFlow: "Вільний перехід",
  oneByOne: "По одному",
  subjectiveNoResultInfo: "Суб'єктивна інформація про статус 'Без результату'",
  candidateResultVisibility: "Видимість результатів для кандидата",
  noResult: "Без результату",
  passPercentageRangeError:
    "Помилка діапазону відсотка для успішного складання",
  attemptsAllowedInfo: "Інформація про дозволені спроби",
  maxAttemptsError: "Помилка: Перевищено максимальну кількість спроб",
  maximumAttemptsInfo: "Інформація про максимальну кількість спроб",
  limitedAttempts: "Обмежена кількість спроб",
  coolOffDescription: "Опис періоду очікування",
  noCoolOffPeriod: "Без періоду очікування",
  waitFor: "Зачекайте на",
  hours: "Години",
  days: "Дні",
  whatLearnersWillSee: "Що побачать студенти",
  unlimitedAttemptsInfo:
    "Для цього оцінювання вам доступна необмежена кількість спроб.",
  waitBeforeNextAttemptPrefix: "Після кожної спроби вам потрібно зачекати",
  waitBeforeNextAttemptSuffix: "перед початком наступної спроби.",
  waitBeforeNextAttempt:
    "Після кожної спроби вам потрібно зачекати {duration} перед початком наступної спроби.",
  singleAttemptInfo: "Для цього оцінювання у вас є 1 доступна спроба.",
  remainingAttemptsInfoPrefix: "У вас є",
  remainingAttemptsInfoMiddle: "з",
  remainingAttemptsInfoSuffix: "спроб доступно для цього оцінювання.",
  remainingAttemptsInfo:
    "У вас є {remaining} з {total} спроб доступно для цього оцінювання.",
  enableCertificate: "Увімкнути сертифікат",
  enableCertificateDescription:
    "Видавайте сертифікат кандидатам після успішного проходження оцінювання.",
  maxAllowed100: "Максимально дозволено 100",
  scheduleAssessment: "Запланувати оцінювання",
  privateAssessmentLabel: "Приватне оцінювання",
  publicAssessmentLabel: "Публічне оцінювання",
  privateAssessmentDescription:
    "Це оцінювання доступне лише за запрошенням і лише в межах визначеного вікна часу початку та завершення.",
  publicAssessmentDescription:
    "Це оцінювання підтримує як самопризначений, так і доступ за запрошенням без фіксованого вікна часу доступу.",
  schedulePublicAssessment: "Запланувати публічне оцінювання",
  successfullyPublishedAssessment: "Оцінювання успішно опубліковано",
  publishWithoutProctoringPrompt:
    "Опублікувати без прокторингу (онлайн-нагляду)?",
  publishAssessmentPrompt: "Опублікувати оцінювання?",
  sectionScoreAnalysis: "Аналіз балів за розділами",
  sectionScoreAnalysisOverview: "Огляд аналізу балів за розділами",
  section: "Розділ",
  noSectionDataAvailable: "Немає доступних даних для цього розділу",
  difficultyLevelAnalysis: "Аналіз за рівнем складності",
  browserViolations: "Порушення правил браузера",
  videoViolations: "Порушення відеозапису",
  times: "Разів",
  statusMessageUnavailable: "Повідомлення про статус недоступне",
  viewViolationEvidence: "Переглянути докази порушення",
  noBrowserViolationsDetected: "Порушень правил браузера не виявлено",
  noVideoViolationsDetected: "Порушень відеозапису не виявлено",
  candidateNotAttemptedCodingMessage:
    "Повідомлення: Кандидат не намагався виконати кодування",
  candidateCode: "Код кандидата",
  candidateScore: "Бал кандидата",
  compilationCount: "Кількість компіляцій",
  submissionCount: "Кількість відправок",
  timeTaken: "Витрачений час",
  testCaseReport: "Звіт про тест-кейси",
  performanceAndCompilationMetrics: "Метрики ефективності та компіляції",
  totalTestCases: "Всього тест-кейсів",
  testCasesPassed: "Успішно пройдено тест-кейсів",
  testCaseDetails: "Деталі тест-кейсу",
  searchQuestions: "Пошук запитань",
  clearSearch: "Очистити пошук",
  question: "запитання",
  isSelected: "вибрано",
  areSelected: "вибрано",
  selected: "Вибрано",
  questionsPerPage: "Запитань на сторінку:",
  publishQuestions: "Опублікувати запитання",
  send: "Надіслати",
  move: "Перемістити",
  publishQuestionsConfirmation:
    "Ви впевнені, що хочете опублікувати {{count}} {{label}}?",
  sendForReviewConfirmation:
    "Ви впевнені, що хочете надіслати {{count}} {{label}} на перевірку?",
  moveToDraftConfirmation:
    "Ви впевнені, що хочете перемістити {{count}} {{label}} до чернеток?",
  bulkPublishDisclaimer:
    "Будь ласка, перевірте, чи всі вибрані запитання є повними, точними та відображаються належним чином перед публікацією.",
  bulkReviewDisclaimer:
    "Будь ласка, перевірте, чи всі вибрані запитання є повними, точними та відображаються належним чином перед відправкою на перевірку.",
  bulkDraftDisclaimer:
    "Будь ласка, перевірте, чи всі вибрані запитання є повними, точними та відображаються належним чином перед переміщенням до чернеток.",
  questionsUnderProcess:
    "Запитання обробляються, будь ласка, натисніть 'переглянути деталі', щоб перевірити їхній статус.",
  mixedStatusesSelected: "Вибрано різні статуси",
  mixedStatusesWarning:
    "Будь ласка, переконайтеся, що всі вибрані запитання мають однаковий статус перед продовженням.",
  selectionLimitReached: "Досягнуто ліміту вибору",
  selectionLimitWarning:
    "Ви не можете вибрати більше ніж {{count}} запитань для масової дії. Зніміть вибір з одного запитання, перш ніж вибирати інше.",
  knowMore: "Дізнатися більше",
  guideLearnersRightDepth:
    "Скеровуйте своїх учнів запитаннями, що відповідають потрібній глибині.",
  bloomCreateDescription:
    "Оцініть здатність студента проектувати, архітектурно будувати або створювати нові системи чи програмні рішення, використовуючи кілька концепцій.",
  bloomEvaluateDescription:
    "Перевірте, чи може студент критично оцінювати код, обґрунтовувати вибір або оцінювати різні рішення.",
  bloomAnalyzeDescription:
    "Протестуйте здатність студента розбирати код, відлагоджувати (дебажити), відстежувати логіку або визначати закономірності в технічних системах.",
  bloomApplyDescription:
    "Оцініть, чи може студент застосовувати концепції для вирішення практичних завдань із кодування або сценаріїв із реального світу.",
  bloomUnderstandDescription:
    "Перевірте, чи може студент розуміти й пояснювати концепції власними словами або інтерпретувати поведінку програми.",
  bloomRememberDescription:
    "Оцініть здатність студента відтворювати базові визначення, синтаксис і фактологічну інформацію.",
  bloomVerbCreate: "Створити",
  bloomVerbDesign: "Спроектувати",
  bloomVerbConstruct: "Конструювати",
  bloomVerbDevelop: "Розробити",
  bloomVerbEvaluate: "Оцінити",
  bloomVerbJustify: "Обґрунтувати",
  bloomVerbDefend: "Захистити",
  bloomVerbAssess: "Оцінити",
  bloomVerbAnalyze: "Проаналізувати",
  bloomVerbDifferentiate: "Диференціювати",
  bloomVerbOrganize: "Організувати",
  bloomVerbCompare: "Порівняти",
  bloomVerbApply: "Застосувати",
  bloomVerbUse: "Використати",
  bloomVerbDemonstrate: "Продемонструвати",
  bloomVerbSolve: "Вирішити",
  bloomVerbExplain: "Пояснити",
  bloomVerbDescribe: "Описати",
  bloomVerbSummarize: "Підсумувати",
  bloomVerbInterpret: "Інтерпретувати",
  bloomVerbList: "Перелічити",
  bloomVerbDefine: "Визначити",
  bloomVerbName: "Назвати",
  bloomVerbRecall: "Згадати",
  bloomVerbRecognize: "Розпізнати",
  bloomCreateExample1:
    "Створити односторінковий додаток (SPA) за допомогою React та Redux.",
  bloomCreateExample2:
    "Спроектувати схему бази даних для додатку спільного користування автомобілями (ride-sharing).",
  bloomCreateExample3:
    "Розробити CI/CD конвеєр (pipeline) за допомогою GitHub Actions.",
  bloomEvaluateExample1:
    "Оцінити плюси та мінуси використання NoSQL замість SQL в архітектурі мікросервісів.",
  bloomEvaluateExample2:
    "Рекомендувати покращення для оптимізації продуктивності React-компонента.",
  bloomAnalyzeExample1:
    "Порівняти продуктивність сортування злиттям (merge sort) та швидкого сортування (quicksort).",
  bloomAnalyzeExample2:
    "Проаналізувати використання пам'яті цією рекурсивною функцією.",
  bloomAnalyzeExample3: "Категоризувати помилки в цьому блоці коду JavaScript.",
  bloomApplyExample1:
    "Застосувати алгоритм бінарного пошуку для знаходження елемента в масиві.",
  bloomApplyExample2:
    "Використати цикл для виведення послідовності Фібоначчі на Python.",
  bloomApplyExample3:
    "Вирішити реальну проблему за допомогою хеш-мапи (hash map).",
  bloomUnderstandExample1:
    "Пояснити, як працює стек, використовуючи принцип LIFO.",
  bloomUnderstandExample2:
    "Описати різницю між var, let та const в JavaScript.",
  bloomUnderstandExample3: "Інтерпретувати результат наведеного SQL-запиту.",
  bloomRememberExample1:
    "Визначити правильний HTML-тег для створення гіперпосилання.",
  bloomRememberExample2:
    "Назвати чотири стовпи об'єктно-орієнтованого програмування (ООП).",
  bloomRememberExample3: "Перелічити примітивні типи даних в Java.",
  commonVerbs: "Поширені дієслова",
  exampleQuestions: "Приклади запитань",
  noExamplesAvailable: "Немає доступних прикладів.",
  candidateResponse: "Відповідь кандидата",
  correctQuestions: "Правильні питання",
  totalQuestions: "Загальна кількість питань",
  correctQuestionPercentage: "Відсоток правильних питань",
  performance: "Результативність",
  level: "РІВЕНЬ",
  noOfQuestions: "КІЛЬКІСТЬ ЗАПИТАНЬ",
  correctAttempts: "ПРАВИЛЬНІ СПРОБИ",
  correctness: "ПРАВИЛЬНІСТЬ",
  partiallyCorrect: "ЧАСТКОВО ПРАВИЛЬНО",
  partiallyCorrectPercentage: "ВІДСОТОК ЧАСТКОВО ПРАВИЛЬНИХ",
  rescheduleAssessmentPrompt:
    'Будь ласка, підтвердьте, чи хочете ви перенести оцінювання під назвою "{{title}}"',
  assessmentAlreadyStarted: "Оцінювання вже розпочалося",
  readMore: "Читати далі",
  best: "Найкраще",
  latest: "Найновіше",
  allQuestions: "Всі питання",
  myQuestions: "Мої питання",
  publicQuestions: "Публічні питання",
  remarks: "Зауваження",
  addRemarks: "Додати зауваження",
  noGroupsAdded: "Груп поки що не додано",
  addGroupInfo:
    "Спершу створіть групу, щоб почати додавати питання. Натисніть кнопку «Додати групу до розділу» нижче, щоб розпочати.",
  exitPreview: "Вийти з попереднього перегляду",
  preview: "Попередній перегляд",
  problemStatementNotAdded: "Проблемне завдання не додано",
  durationDayUnit: "день",
  durationDaysUnit: "дні",
  durationHourUnit: "год",
  durationHoursUnit: "год",
  durationMinuteUnit: "хв",
  customFieldAddedForSingleLanguage:
    "Користувацьке поле {{fieldLabel}} додано для {{current}} з {{total}} мови",
  customFieldAddedForMultipleLanguages:
    "Користувацьке поле {{fieldLabel}} додано для {{current}} з {{total}} мов",
  email: "Електронна пошта",
  tagInputHint: "Додайте через кому",
  enterOptions: "Введіть варіанти",
  groupNotFound: "Групу не знайдено",
  sheetNotFound: "Аркуш не знайдено",
  missingHeaders: "Обов'язкові заголовки відсутні",
  assetNotFound: "Ресурс не знайдено",
  noValidDataFound: "Не знайдено дійсних даних",
  notFoundPID: "Учасника не знайдено.",
  invalidParticipants: "Недійсний учасник.",
  alreadyAdded: "Учасника вже додано.",
  duplicateData: "Знайдено дубльовані дані.",
  invalidData: "Недійсні дані.",
  warnings: "Попередження",
  assignedToMyself: "Мені призначено (Самонавчання)",
  assignedByMe: "Призначено мною (Мої Завдання)",
  urlCopiedToClipboard: "URL скопійовано в буфер обміну!",
  failedToCopyUrl: "Помилка при копіюванні URL.",
  content: "Контент",
  platformHelp: "Plattformshjälp",
  privacyPolicy: "Integritetspolicy",
  logout: "Вийти",
  logoutConfirmTitle: "Ви впевнені, що хочете вийти?",
  logoutConfirmDescription:
    "Йдете? Ви завжди можете повернутися і продовжити з того місця, де зупинилися.",
  stayEngaged: "Залишатися залученим"
} as const;
export default uk;
